export default function WhatsAppButton() {
  const phoneNumber = '48601932348'; // Format: country code + number without +
  const message = encodeURIComponent('Dzień dobry, chciałbym uzyskać więcej informacji o Państwa ofercie.');

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group hover:scale-110 animate-bounce"
      aria-label="Skontaktuj się przez WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Napisz do nas na WhatsApp
      </span>
    </a>
  );
}
